import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';

export default function MasterclassMenuHeader({}) {
    const [active, setActive] = useState('next')

    useEffect(() => {
        const event = new CustomEvent('masterclass_menu_tabs', {detail: active})
        document.dispatchEvent(event)
    }, [active])

    return (
        <Container>
            <MenuContainer>
                <Item
                    isActive={active === 'next'}
                    onClick={() => setActive('next')}>Proximas</Item>
                <Item
                    isActive={active === 'old'}
                    onClick={() => setActive('old')}>Antiguas</Item>
            </MenuContainer>

            <SelectContainer>
                <CourseName>Clases en directo</CourseName>
            </SelectContainer>
        </Container>
    )
}

const CourseName = styled.div`
    cursor:pointer;
    &:hover {
        color: white;
    }
`
const SelectContainer = styled.div`
    padding-right: 8px;
    color: black;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
`
const MenuContainer = styled.div`
   display: flex;
    flex-direction: row;
`

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content:space-between;
    padding-top: 43px;

`

const Item = styled.div`
    padding-left: 8px;
    padding-right: 8px;
    font-size: 14px;
    cursor: pointer;
    font-weight: ${props => props.isActive ? 'bold' : 'lighter'};
    color: ${props => props.isActive ? 'white' : '#5F676D'};
`


if (document.getElementsByTagName('masterclass-tool-menu-header')) {
    const elms = document.getElementsByTagName('masterclass-tool-menu-header')

    for (let elm of elms) {

        ReactDOM.render(<MasterclassMenuHeader />, elm);
    }
}
